import { Box } from '@mui/material';
import { Controls, MiniMap, Node, NodeTypes, ReactFlow, ReactFlowProvider } from '@xyflow/react';
import { useWorkflowGraph } from './graph/hooks/use-workflow-graph';
import { AutoFitView } from './auto-fit-view';
import { EnrollNode } from '../../pages/create/nodes/enroll-node/enroll-node';
import '@xyflow/react/dist/style.css';
import { PlusNode } from '../../pages/create/nodes/plus-node';
import { WaitNode } from '../../pages/create/nodes/wait-node';
import { ActionNode } from '../../pages/create/nodes/action-node/action-node';

const nodeTypes: NodeTypes = {
  enroll: EnrollNode,
  add: PlusNode,
  wait: WaitNode,
  action: ActionNode,
};

type WorkflowCanvasProps = {
  graphControl: ReturnType<typeof useWorkflowGraph>;
  onNodeDoubleClick: (node: Node) => void;
};

export const WorkflowCanvas = ({ graphControl, onNodeDoubleClick }: WorkflowCanvasProps) => {
  return (
    <Box flex={1}>
      <ReactFlowProvider>
        <ReactFlow
          nodes={graphControl.nodes}
          edges={graphControl.edges}
          nodeTypes={nodeTypes}
          onNodesChange={graphControl.onNodesChange}
          onEdgesChange={graphControl.onEdgesChange}
          onNodeDoubleClick={(_, node) => onNodeDoubleClick(node)}
          nodesDraggable={false}
          fitView
        >
          <Controls />
          <MiniMap />

          <AutoFitView nodeCount={graphControl.nodes.length} />
        </ReactFlow>
      </ReactFlowProvider>
    </Box>
  );
};
